import { h } from 'preact';

const Countdown = ({ noLine, alignment, timeLeft = '--' }) => {
  let klass = 'countdown';
  const timeLeftIsNumber = typeof timeLeft === 'number' && isFinite(timeLeft);

  if (alignment === 'center') {
    klass += ' countdown--center';
  }

  if (noLine) {
    klass += ' countdown--noline';
  }

  let output = null;

  if (timeLeft === '--') {
    output = `Next update in ${timeLeft}`;
  } else if (timeLeftIsNumber) {
    output = `Next update in :${timeLeft}`;
  } else if (timeLeft === 'Updating!') {
    output = timeLeft;
  }
  return (
    <div className={klass}>{output}</div>
  );
};

export default Countdown;



// WEBPACK FOOTER //
// ./components/countdown.js